import React, { FC } from "react";
import { createGlobalStyle } from "styled-components";
import { InputNumber } from "primereact/inputnumber";
import Container from "saur_ui_library/src/Atoms/Container/Container";

type NotationProps = {
  className: string;
  placeholder: string;
  onValueChange: any;
  id: string;
  value: any;
  max?:number;
  disabled?:boolean;
};

const InputNotation: FC<NotationProps> = (props) => {
  return (
    <Container className="global-notation sds-reset-style">
        <Styles />
        <InputNumber
          className={`notation ${props.className}`}
          id={`id-notation ${props.id}`}
          placeholder={props.placeholder}
          value={props.value}
          onValueChange={props.onValueChange}
          max={props.max}
          disabled={props.disabled}
          minFractionDigits={2}
          maxFractionDigits={2}
        />
    </Container>
  );
};

export const Styles = createGlobalStyle`
.global-notation.sds-reset-style{
    .notation{
        input.p-inputtext.p-component.p-inputnumber-input.p-filled{
            border: 1px solid #CCE8F6;
            border-radius: 5px;
            width: 63px;
            height: 43px;
            text-align: center;
            background-color: white;
            margin-top: 10px;
        }
    }
} 
  `;

export default InputNotation;
